import FacebookSvg from "../../assets/shared/desktop/facebook.svg";
import YoutubeSvg from "../../assets/shared/desktop/youtube.svg";
import TwitterSvg from "../../assets/shared/desktop/twitter.svg";
import PinterestSvg from "../../assets/shared/desktop/pinterest.svg";
import InstagramSvg from "../../assets/shared/desktop/instagram.svg";

export const SocialData = [
	{
		src: FacebookSvg,
	},
	{
		src: YoutubeSvg,
	},
	{
		src: TwitterSvg,
	},
	{
		src: PinterestSvg,
	},
	{
		src: InstagramSvg,
	},
];
